import { getUpdatedDetailsReq } from "../redux/specialist-slices/auth.slice"
import { useDispatch, useSelector } from "react-redux"
import { Cookies } from "react-cookie"
import { useEffect } from "react"

const cookies = new Cookies()

function useCurrentStep() {
  const dispatch = useDispatch()
  const token = cookies.get("token")
  const { specialist } = useSelector(state => state.specialistSlice)

  useEffect(() => {
    if (token) {
      dispatch(getUpdatedDetailsReq())
    }

    // eslint-disable-next-line
  }, [dispatch])

  return specialist?.verification?.currentStep || "login"
}

export default useCurrentStep